import { FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { ProfileInfoUsernameProps } from './props';
import styles from './styles.module.scss';
import { UpdatePlayerInputDto } from '@/services/dto/players/update-player-input.dto';
import { usePlayerStatistics, useUpdatePlayer } from '@/api/players';
import { useUserAccount } from '@/api/user';
import { useToggle } from '@starsoft/common/hooks';
import { UpdateUsernameForm } from './UpdateUsernameForm';
import { ProfileInfoPicure } from './Picture';

export default function ProfileInfoUsername({
  username,
}: ProfileInfoUsernameProps) {
  const [showForm, toggleShowForm] = useToggle();
  const { isPending, updatePlayer } = useUpdatePlayer({
    customOnSuccess: toggleShowForm,
  });
  const { player } = usePlayerStatistics();
  const { user } = useUserAccount();
  const isLoggedUserAccount: boolean = player?.id === user?.player?.id;

  const methods: UseFormReturn<UpdatePlayerInputDto> =
    useForm<UpdatePlayerInputDto>({
      defaultValues: { username },
    });

  const { handleSubmit } = methods;

  function onSubmit(data: UpdatePlayerInputDto) {
    if (!data?.username || !isLoggedUserAccount) {
      return;
    }

    updatePlayer({
      ...data,
      username: data?.username == player?.username ? undefined : data?.username,
    });
  }

  return (
    <FormProvider {...methods}>
      <div className={styles.container__wrapper}>
        <form
          className={styles.container__wrapper}
          onSubmit={handleSubmit(onSubmit)}
        >
          <ProfileInfoPicure isEditing={showForm} />
          <div className={styles.container}>
            {showForm && isLoggedUserAccount ? (
              <UpdateUsernameForm isPending={isPending} back={toggleShowForm} />
            ) : (
              <>
                <span className={styles.container__text}>{username}</span>
                {isLoggedUserAccount && (
                  <i
                    className={`${styles.container__icon} fa-solid fa-pencil`}
                    onClick={toggleShowForm}
                  />
                )}
              </>
            )}
          </div>
        </form>
      </div>
    </FormProvider>
  );
}
